export class AuthUser {
  id = '';
  name = '';
  email = '';
  permitNumber = '';
  roles: string[] = [];
  language = 'fr';
  sub = ''
}
